export default __webpack_public_path__ + "static/media/hiring.aee16657.svg";